<template>
  <div>
    <div v-if="gameStep === 'choose-counter'">
      <CounterSelector />
    </div>
    <div v-else-if="gameStep === 'choose-deck-number'">
      <DeckNumberSelector />
    </div>
    <div v-else>
      <transition name="slide-fade">
        <Game v-if="show" />
      </transition>
    </div>
  </div>
</template>

<script>
import store from "../store";
import { mapState } from "vuex";
import CounterSelector from "./CounterSelector";
import Game from "./Game.vue";
import DeckNumberSelector from "./DeckNumberSelector";

export default {
  data: function() {
    return {
      show: false
    };
  },
  name: "Bootstrap",
  store,
  components: {
    CounterSelector,
    DeckNumberSelector,
    Game
  },
  updated() {
    this.show = true;
  },
  computed: {
    gameStep() {
      return this.$store.getters.getGameStep;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Bootstrap.vue